<img mat-card-avatar [src]="action.realtor | realtor" [matTooltip]="action.realtor | realtorTooltip"/>
